<template>
  <section class="pao-resume">
    <!-- Per-product application -->
    <div class="content-devx margin-half" style="padding: 0">
      <div style="padding: 4px 4px 0 4px">
        <div class="main-title-content">
          {{ $t('Utilities.pao.productApplicationTitle') }}
        </div>
      </div>
      <div style="padding: 0 4px">
        <div class="content-separatos">
          <DxDataGrid
            class="pao-product-grid"
            :data-source="productRows"
            :show-borders="true"
            :row-alternation-enabled="true"
            :word-wrap-enabled="true"
            :column-auto-width="true"
            :show-row-lines="true"
            :show-column-lines="true"
          >
            <DxPaging :enabled="false" />
            <DxColumn
              data-field="name"
              :caption="$t('Utilities.pao.productColumn')"
              :allow-sorting="false"
              :width="250"
              :fixed="true"
              fixed-position="left"
            />
            <DxColumn
              data-field="fertilizing_material_name"
              :caption="$t('Utilities.pao.fertilizingMaterialColumn')"
              :allow-sorting="false"
            />
            <DxColumn
              data-field="application_method_name"
              :caption="$t('Utilities.pao.applicationMethodColumn')"
              :allow-sorting="false"
            />
            <DxColumn
              data-field="fertilization_type_name"
              :caption="$t('Utilities.pao.fertilizationTypeColumn')"
              :allow-sorting="false"
            />
            <DxColumn
              v-if="hasMachinery"
              data-field="distribution_machinery"
              :caption="$t('Utilities.pao.machineryColumn')"
              :allow-sorting="false"
            />
          </DxDataGrid>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { DxDataGrid, DxColumn, DxPaging } from 'devextreme-vue/data-grid';

export default {
  name: 'PaoResume',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
  },
  props: {
    fertilization: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    hasMachinery() {
      return this.productRows.some(
        (row) => (row.distribution_machinery ?? '').toString().trim().length > 0,
      );
    },
    productRows() {
      return (this.fertilization?.contribution_products ?? []).map((p) => ({
        name: p.product_name ?? p.name,
        fertilizing_material_name:
          p.fertilizing_material_name ?? p.fertilizing_material?.name ?? null,
        application_method_name:
          p.application_method_name ?? p.application_method?.name ?? null,
        fertilization_type_name:
          p.fertilization_type_name ?? p.fertilization_type?.name ?? null,
        distribution_machinery: p.distribution_machinery ?? null,
      }));
    },
  },
};
</script>

<style scoped lang="scss">
.pao-product-grid::v-deep .dx-header-row td[role='columnheader'] {
  text-transform: capitalize;
}
</style>
